import { FormControl, MenuItem, Select, Stack } from "@mui/material";
import { useTranslation } from "shared/hooks/useTranslation";
import MoneyInput from "shared/ui/MoneyInput";

const CURRENCIES = ["ARS", "USD"] as const;

interface AmountCurrencyRowProps {
    amount: string | number;
    currency: string;
    onAmountChange: (value: string) => void;
    onCurrencyChange: (value: string) => void;
    disabled?: boolean;
}

export default function AmountCurrencyRow({ amount, currency, onAmountChange, onCurrencyChange, disabled }: AmountCurrencyRowProps) {
    const { t } = useTranslation();
    return (
        <Stack direction="row" spacing={1}>
            <MoneyInput
                fullWidth
                size="small"
                placeholder={t("forms.amount")}
                value={amount ?? ""}
                onValueChange={onAmountChange}
                disabled={disabled}
            />
            <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select value={currency} onChange={(e) => onCurrencyChange(e.target.value)} disabled={disabled} displayEmpty>
                    <MenuItem value="" disabled>{t("forms.currency")}</MenuItem>
                    {CURRENCIES.map((c) => (<MenuItem key={c} value={c}>{c}</MenuItem>))}
                </Select>
            </FormControl>
        </Stack>
    );
}
